module.exports = __webpack_public_path__ + "img/emergency_kit_02.96f55999.jpg";